import {
    Button,
    CircularProgress,
    ClickAwayListener,
    Dialog,
    DialogTitle,
} from "@mui/material";
import { FormEvent, useEffect, useRef, useState } from "react";
import { IContext, IGroupUsers, ITopic } from "../../types";
import { UserListPanel } from "./UserListPanel";
import { useAtomInstance } from "@zedux/react";
import { messageReceiverAtom } from "../../atoms/messageReceiverAtom";

interface NewGroupDialogProps {
    open: boolean;
    onClose: () => void;
    context: IContext;
    isChannel: boolean;
    onGroupCreated: (topic: ITopic) => void;
}

const default_pic = '/app/assets/image/profile.jpg'

export function NewGroupDialog({
    onClose,
    context,
    isChannel,
}: NewGroupDialogProps) {
    const [groupName, setGroupName] = useState("")
    const [filteredName, setFilteredName] = useState("")
    const [showNameError, setShowNameError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [toggle, setToggle] = useState(false)
    const userSet = useRef<Set<number>>(new Set())

    const [image, setImage] = useState({})
    const { image_url, image_id } = image || {} as any

    const label = isChannel ? "کانال" : "گروه";

    const { create_group } = useAtomInstance(messageReceiverAtom, [context]).exports;

    const handleToggle = (userId: number) => {
        if (userSet.current.has(userId)) {
            userSet.current.delete(userId)
        } else {
            userSet.current.add(userId)
        }
        setToggle((v) => !v);
    };

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (!groupName.trim()) {
            setShowNameError(true)
            return;
        }
        setShowNameError(false)
        setLoading(true)
        setError("")
        try {
            const result = await create_group(
                groupName.trim(),
                isChannel,
                Array.from(userSet.current),
                image_id
            );

            console.log(result, 'creation')

            if (result.success && result.topic) {
                // onGroupCreated(result.topic);
                // Reset
                userSet.current.clear()
                setGroupName("")
                setFilteredName("")
                onClose();
            } else {
                setError(result.message || "خطا در ایجاد گروه")
            }
        } catch (e: any) {
            setError(e?.message ?? "خطا در ایجاد گروه")
        } finally {
            setLoading(false)
        }
    }


    const profileUploadRef = useRef<HTMLDivElement | null>(null);

    // Observe img data for detecting upload successful from ChangeAvatar component (from another project)
    useEffect(() => {
        console.log('use effect run', open, profileUploadRef.current)
        const el = profileUploadRef.current
        if (!el) return

        const handler = (e: Event) => {
            const ev = e as CustomEvent<{ image_id: string, image_url: string }>
            console.log(ev)
            setImage({ ...ev.detail })
        };

        el.addEventListener("image-id-change", handler);

        return () => el.removeEventListener("image-id-change", handler)
    }, [setImage]);

    return (

        <div className="gap-2 p-4" >
            <form className="flex flex-col gap-2 w-full" onSubmit={handleSubmit}>
                <DialogTitle className="px-0 pt-0 font-bold">
                    ایجاد {label} گفت‌وگو
                </DialogTitle>

                <div className="flex flex-row-reverse gap-4">
                    <div
                        className="flex flex-col justify-evenly items-center px-4 cursor-pointer"
                        data-button-action="general-profile-upload" data-z-index="2500"
                        ref={profileUploadRef}
                    >
                        <img className="rounded-full size-18 object-contain aspect-square"
                            src={image_url || default_pic}
                        />
                        <span className="text-xs">تصویر {label}</span>
                    </div>
                    <div className="flex flex-col gap-1 grow">
                        <label className="block mb-1 font-medium text-sm">عنوان {label}</label>
                        <input
                            value={groupName}
                            onChange={(e) => {
                                setGroupName(e.target.value);
                                setShowNameError(false);
                            }}
                            type="text"
                            className={`rounded w-full p-2 border ${showNameError ? 'border-red-500' : 'border-stone-200'}`}
                            placeholder={`عنوان ${label} را وارد کنید`}
                        />
                        {showNameError && (
                            <span className="block mt-1 text-red-500 text-sm">عنوان {label} نمی‌تواند خالی باشد</span>
                        )}

                        <input
                            value={filteredName}
                            onChange={(e) => setFilteredName(e.target.value)}
                            type="text"
                            className="mb-3 p-2 border border-stone-200 rounded w-full"
                            placeholder="جستجوی نام..."
                        />
                    </div>
                </div>



                {error && (
                    <span className="block mb-2 text-red-500 text-sm">{error}</span>
                )}

                <div className="max-h-80 overflow-y-auto">
                    <UserListPanel
                        filteredName={filteredName}
                        mode="checkbox"
                        userSet={userSet.current}
                        onToggle={handleToggle}
                        toggle={toggle}
                    />
                </div>

                <div className="flex justify-end gap-2 mt-3 pt-2 border-stone-200 border-t">
                    <Button onClick={onClose} type="button">
                        انصراف
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        type="submit"
                        sx={{ borderRadius: "0.5rem" }}
                    >
                        {loading ? (
                            <CircularProgress size={20} color="inherit" />
                        ) : (
                            `ایجاد ${label}`
                        )}
                    </Button>
                </div>
            </form>
        </div>
    )
}
